const MaterialUtils = {
  recoverMaterialType: materialTypeId => {
    switch (materialTypeId) {
      case 1: {
        return {
          icon: 'mdi-video',
          material: 'Videoaula'
        }
      }
      case 2: {
        return {
          icon: 'mdi-graph',
          material: 'Mapas Mental/Fluxogramas'
        }
      }
      case 3: {
        return {
          icon: 'mdi-file-document-box',
          material: 'Resumo'
        }
      }
      case 4: {
        return {
          icon: 'mdi-cube-scan',
          material: 'Modelo 3D'
        }
      }
      case 5: {
        return {
          icon: 'mdi-frequently-asked-questions',
          material: 'Simulado'
        }
      }
      case 6: {
        return {
          icon: 'mdi-comment-question',
          material: 'Questão'
        }
      }
      case 7: {
        return {
          icon: 'mdi-text-subject',
          material: 'Texto'
        }
      }
    }
  }
}

export default MaterialUtils
